import { useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import Aos from "aos";
import 'aos/dist/aos.css';

import ServiceImg1 from '../../assets/img/service-img1.png';
import ServiceImg2 from '../../assets/img/service-img2.png';

import '../../assets/css/container/services.css';

const Services = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="main-service" id="services">
      <div className="heading" data-aos="fade-down">
        <div className="title-bar">
          <h3>Our Signature Styles</h3>
        </div>
        <p className="subheader">Tailored looks for every client</p>
      </div>

      <div className="service-imgs">
        {/* Ladies Section */}
        <div className="service-card" data-aos="fade-right">
            <img src={ServiceImg1} alt="Ladies Hair Services" />
            <div className="overlay">
              <span className="overlay-text">LADIES</span>
              <p>Protective styles, weaves, and natural hair care.</p>
              <div className="quick-links">
                <HashLink smooth to="/ladies#styles">View Styles</HashLink>
                <a href="tel:5714919196">Book Now</a>
              </div>
            </div>
        </div>

        {/* Guys Section */}
        <div className="service-card" data-aos="fade-left">
            <img src={ServiceImg2} alt="Men's Grooming Services" />
            <div className="overlay">
              <span className="overlay-text">GUYS</span>
              <p>Haircuts, beard grooming, and etc.</p>
              <div className="quick-links">
                <HashLink smooth to="/gentlemen#styles">View Styles</HashLink>
                <a href="tel:5714919196">Book Now</a>
              </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
